import SegmentedControl from '@/components/base/SegmentedControl';
import CustomSelect from '@/components/base/CustomSelect';
import { ledgerSources } from '@/mocks/members';

const typeOptions = ['All', 'Earn', 'Redeem', 'Adjust'];

interface LedgerFiltersProps {
  query: string;
  onQueryChange: (value: string) => void;
  type: string;
  onTypeChange: (value: string) => void;
  source: string;
  onSourceChange: (value: string) => void;
  resultCount: number;
  total: number;
}

export default function LedgerFilters({
  query,
  onQueryChange,
  type,
  onTypeChange,
  source,
  onSourceChange,
  resultCount,
  total,
}: LedgerFiltersProps) {
  return (
    <div className="flex flex-col gap-4 rounded-2xl border border-background-200/90 bg-background-50/95 shadow-sm p-4 md:p-5">
      <div className="flex flex-col lg:flex-row lg:items-center gap-4">
        <div className="flex items-center gap-2 bg-background-100/80 border border-background-200/90 rounded-xl px-3.5 py-2.5 flex-1 min-w-0 shadow-2xs">
          <i className="ri-search-line text-foreground-400 text-sm"></i>
          <input
            type="text"
            value={query}
            onChange={(event) => onQueryChange(event.target.value)}
            placeholder="Search member, description or txn ID..."
            className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
          />
          {query && (
            <button
              type="button"
              onClick={() => onQueryChange('')}
              className="w-5 h-5 flex items-center justify-center rounded-full text-foreground-400 hover:text-foreground-700 cursor-pointer"
              aria-label="Clear search"
            >
              <i className="ri-close-line"></i>
            </button>
          )}
        </div>

        <div className="flex flex-wrap items-center gap-3">
          <SegmentedControl options={typeOptions} value={type} onChange={onTypeChange} />
          <CustomSelect
            value={source}
            onChange={onSourceChange}
            options={ledgerSources}
            align="right"
            searchable
            searchPlaceholder="Search source..."
            className="min-w-[170px]"
          />
        </div>
      </div>

      <p className="text-xs text-foreground-500">
        Showing <span className="font-semibold text-foreground-800">{resultCount}</span> of {total} events
      </p>
    </div>
  );
}
